import { ref, shallowRef, type Ref, watch } from 'vue';
import type { OperatorType } from '@/models/operator';
import type { CallAction } from '@/models/callLog';
import { NashDeliveryOperatorsAbTest, ComparisonFramingAbTest, OrderRidesMapBasedAbTest } from '@/constants/abTest';
import { abTestService } from '../abTests';

export const meOperator = shallowRef<OperatorType | null>(null);
watch(
  () => meOperator.value?.id,
  async (id) => {
    if (!id) {
      return;
    }

    const plansBeforeSoftRegAbTest = await abTestService
      .assignAbTestPerStrategy({ abTestName: 'plans_before_soft_reg', associatedObjectId: id, associatedObjectType: 'operator' })
      .catch((err) => null);

    isPlansBeforeSoftRegTest.value = plansBeforeSoftRegAbTest?.groupType === 'test';

    const orderRidesMapBasedAbTest = await abTestService
      .assignAbTestPerStrategy({ abTestName: OrderRidesMapBasedAbTest, associatedObjectId: id, associatedObjectType: 'operator' })
      .catch((err) => null);

    isOrderRidesMapBasedTest.value = orderRidesMapBasedAbTest?.groupType === 'test';

    const nashDeliveryAbTest = await abTestService
      .assignAbTestPerStrategy({
        abTestName: NashDeliveryOperatorsAbTest,
        associatedObjectId: id,
        associatedObjectType: 'operator',
      })
      .catch((err) => null);

    canOfferNashDelivery.value = nashDeliveryAbTest?.groupType === 'test';

    const comparisonFramingAbTest = await abTestService
      .assignAbTestPerStrategy({ abTestName: ComparisonFramingAbTest, associatedObjectId: id, associatedObjectType: 'operator' })
      .catch((err) => null);

    isComparisonFramingTest.value = comparisonFramingAbTest?.groupType === 'test';
  },
);

export const isPlansBeforeSoftRegTest = ref<boolean | undefined>();
export const canOfferNashDelivery = ref(false);
export const isOrderRidesMapBasedTest = ref<boolean | undefined>();

export const isComparisonFramingTest = ref<boolean | undefined>();

export const operatorReportData: Ref<{
  callLogId?: string;
  groceryId?: string;
  rideId?: string;
  customerName: string;
  customerPhoneNumber: string;
  operatorName?: string;
  teamLeadId?: string;
  incidentDateTime: string;
  callActions: CallAction[];
} | null> = ref(null);
